import type { CSSProperties, MouseEventHandler, ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  padding?: number
  style?: CSSProperties
  onClick?: MouseEventHandler<HTMLDivElement>
}

export function Card({ children, padding = 24, style, onClick }: CardProps) {
  return (
    <div onClick={onClick} style={{
      background: 'var(--bg-card)',
      border: '1px solid var(--border-subtle)',
      borderRadius: 16,
      padding,
      boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
      boxSizing: 'border-box',
      minWidth: 0,
      maxWidth: '100%',
      ...style,
    }}>
      {children}
    </div>
  )
}
